import {useCallback} from 'react'
import {useMappedState} from 'redux-react-hook'
import useRouter from 'hooks/useRouter'
import ApiSdk from 'services/callApi'
import {isTestnet} from 'constants'
import {Notification} from '@binance/uikit'

export default function useOpenAccount (i18n) {
  const router = useRouter()
  const {lng = 'en'} = router.query
  const mapState = useCallback(state => isTestnet || state?.openAccountInfo?.isOpenAccount, [])
  const handleOpenAccount = useCallback(async () => {
    const res = await ApiSdk.futures.openAccount({
      lang: lng
    })

    if (res?.success || res?.rootUserId) {
      Notification({
        content: i18n['openAccout-successOpen'] || 'open success',
        type: 'success',
        duration: 3000
      })
      setTimeout(() => {
        // eslint-disable-next-line no-unused-expressions
        window?.location?.reload()
      }, 3000)
    } else {
      Notification({
        content: res?.message || i18n['openAccout-failureOpen'] || 'open failured',
        type: 'error',
        duration: 3000
      })
    }
  }, [i18n, lng])

  return {
    isOpenAccount: useMappedState(mapState),
    handleOpenAccount
  }
}
